import {
  dispatchEventToDevConsole,
  dispatchEventToParentWindow,
  EVENT_TYPES,
  pushEventToGTMDataLayer,
} from "nemuru-components";

export const EVENT_CHANNELS = {
  parentWindow: {
    id: "parentWindow",
    activeEventTypes: [],
  },
  devConsole: {
    id: "devConsole",
    activeEventTypes: [
      EVENT_TYPES.milestoneCompleted,
      EVENT_TYPES.progress,
      EVENT_TYPES.action,
      EVENT_TYPES.requestDispatch,
      EVENT_TYPES.requestFulfilled,
      EVENT_TYPES.requestRejected,
      EVENT_TYPES.error,
    ],
  },
  GTMDataLayer: {
    id: "GTMDataLayer",
    activeEventTypes: [
      EVENT_TYPES.milestoneCompleted,
      EVENT_TYPES.progress,
      EVENT_TYPES.error,
    ],
  },
};

const EVENT_CHANNELS_FUNCTIONS = {
  [EVENT_CHANNELS.parentWindow.id]: dispatchEventToParentWindow,
  [EVENT_CHANNELS.devConsole.id]: dispatchEventToDevConsole,
  [EVENT_CHANNELS.GTMDataLayer.id]: pushEventToGTMDataLayer,
};

export const MILESTONES = {
  // a comps
  APP_STARTED: "APP_STARTED",
  KYC_ELECTRONIC_ID_ERROR: "KYC_ELECTRONIC_ID_ERROR",
  KYC_DOCUMENT_NUMBER_VALIDATION_RETRY: "KYC_DOCUMENT_NUMBER_VALIDATION_RETRY",
  KYC_COMPLETED: "KYC_COMPLETED",
  INCOME_COMPLETED: "INCOME_COMPLETED",
  PROFESSIONAL_DETAILS_COMPLETED: "PROFESSIONAL_DETAILS_COMPLETED",
  APPLICATION_REQUESTED: "APPLICATION_REQUESTED",
  APPLICATION_CREATED_IN_LENDER: "APPLICATION_CREATED_IN_LENDER",
  DOCUMENT_UPLOADED: "DOCUMENT_UPLOADED",
  DOCUMENTATION_CONFIRMED: "DOCUMENTATION_CONFIRMED",
  CONTRACT_SIGNED: "CONTRACT_SIGNED",
};

export const EVENTS_LINKED_BY_ACTION_TYPES = (action, context) => {
  return {
    SET_MODULE_SKIPPED: {
      name: `SKIPPED.${context.currentModuleObject?.id}`,
      type: EVENT_TYPES.progress,
      payload: {
        module: context.currentModuleObject?.id,
        screenPath: context.currentModuleObject?.id,
        status: "skipped",
      },
    },
    REQUEST_UPLOAD_BORROWER_DOCUMENTATION_FULFILLED: {
      name: MILESTONES.DOCUMENT_UPLOADED,
      type: EVENT_TYPES.milestoneCompleted,
    },
    REQUEST_PATCH_SET_DOCUMENTS_CONFIRMED_FULFILLED: {
      name: MILESTONES.DOCUMENTATION_CONFIRMED,
      type: EVENT_TYPES.milestoneCompleted,
    },
  };
};

export const EVENTS_CONFIG = {
  EVENT_CHANNELS,
  EVENT_CHANNELS_FUNCTIONS,
  EVENTS_LINKED_BY_ACTION_TYPES,
};
